<match-display-wrapper
    matchLabel="{{ l10nKeys.botManagementLabel | vtranslate }}"
    matchCriteria="{{ editable.config.match_operation | enumValueLabel : 'MatchOperation' }}"
>
    <div *ngFor="let classification of classificationTexts; trackBy: trackByIndex">
        {{ classification }}
    </div>
</match-display-wrapper>
